// Layout.js
import React, { useState } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import CookieConsent from "./CookieConsent";

// ⬇️ új:
import CartDrawer from "./cart/CartDrawer";

export default function Layout({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <main className="min-h-screen bg-white text-gray-800">
      <Navigation menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      {children}
      <Footer />
      <CookieConsent />

      {/* ⬇️ egyszer, globálisan elég */}
      <CartDrawer />
    </main>
  );
}
